import React from 'react';
import {Link} from 'react-router';
import {Trans, useTranslation} from 'react-i18next';
import BrandMark from '../BrandMark';
import Subscribe from '../Subscribe';
import config from '../../config';
import {localePath} from '../../languages';
import {openCookieSettings} from '../../cookieConsent';

const Footer = () => {
    const {t, i18n} = useTranslation();
    const home = path => localePath(path, i18n.language);
    const columns = [
        {title: t('design.product'), links: [[t('buttons.create'), home('/#generator')], [t('header.howItWorks'), home('/#howItWorks')], [t('header.examples'), home('/#examples')], [t('design.faqNav'), home('/#faq')]]},
        {title: t('footer.help'), links: [[t('footer.aboutUs'), home('/about')], [t('footer.contactUs'), `mailto:${config.contactEmail}`], [t('footer.instagram'), config.instagramUrl], [t('footer.pinterest'), config.pinterestUrl], [t('footer.tiktok'), config.tiktokUrl], [t('footer.blog'), home('/blog')]]},
        {title: t('footer.terms'), links: [[t('footer.termsOfUse'), home(config.termsOfUseUrl)], [t('footer.privacyPolicy'), home(config.privacyPolicyUrl)], [t('footer.cookiePolicy'), home(config.cookiePolicyUrl)]]},
    ];
    return (
        <footer className="site-footer">
            <div className="design-container">
                <div className="footer-grid">
                    <div>
                        <Link to={home('/')} className="brand"><BrandMark/><span>YourLovely<span className="brand-accent">.Place</span></span></Link>
                        <Subscribe/>
                    </div>
                    <div className="footer-columns">
                        {columns.map(({title, links}) => <nav key={title} aria-label={title}><h3>{title}</h3><ul>{links.map(([label, href]) => <li key={label}>{href.startsWith('/') ? <Link to={href}>{label}</Link> : <a href={href}>{label}</a>}</li>)}</ul></nav>)}
                    </div>
                </div>
                <div className="footer-bottom">
                    <span>© 2023 - {new Date().getFullYear()} YourLovely.Place</span>
                    <button type="button" className="footer-cookie-settings" onClick={openCookieSettings}>{t('cookie.settings')}</button>
                    <span><Trans i18nKey="gdpr.text">Site uses <a href={home(config.cookiePolicyUrl)} target="_blank" rel="noreferrer">cookies</a></Trans></span>
                </div>
            </div>
        </footer>
    );
};
export default Footer;
